//import main package
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';

//Import Obsevable to make service asynchronous
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { of } from 'rxjs/observable/of';
import { forkJoin } from "rxjs/observable/forkJoin";

//Import for messages
import { MessageService } from 'services/message.service'

//import global function
import * as _ from 'underscore';
import { PagerService } from 'services/index';
import { AuthService } from 'services/auth.service';
import { GlobalService } from 'services/global.service';

import { Pager } from '../../../pager';

@Injectable()
export class DashboardService {
  domain = this.authService.domain;  
  notices = new Subject<any[]>();
  pagerProcess;
  pager = new Subject<Pager>();
  sortingConsultant = 'course_started_at';//基準日新しい順に変更//'class_name';
  Acs = false;//true;
  totalItems = this.globalService.totalItems;

  // variable for dashboard data
  dashboardsAll : any[];
  dashboards = new Subject<any[]>();
  dashboards$ = this.dashboards.asObservable();
  pager$ = this.pager.asObservable();
  notices$ = this.notices.asObservable();

  public deletedStudentPrivateDataDate: Subject<any> = new Subject();
  public deletedStudentPrivateDataDateState = this.deletedStudentPrivateDataDate.asObservable();

  processing = false; // variable for loading fucntion
  
  // lisst of status array
  //（※gat_frontend/src/app/services/Enums/courseStatus.tsにも同じようなのを発見したので、あとでそこを読み込むように直したほうがいいかも）//gh
  //（※読み込み方はdashboard.component.ts:60行目あたりの、courseStatus = new this.globalService.enumHelpers.CourseStatus();って感じで読み込むと思われる）//gh
  statusArr = [
    {
      id : '',
      name: 'すべて',
    },
    {
      id : 1,
      name: '作成中 (作成完了)',
    },
    {
      id : 2,
      name: '配信前',
    },
    {
      id : 3,
      name: '配信中',
    },
    {
      id : 4,
      name: '最終配信済み',
    },
    {
      id : 5,
      name: '終了',
    },  
    {
      id : 6,
      name: '配信停止',
    }
  ];

  // list of sorting data array 
  sortingArray = [
    {
      id: 0,
      title: 'クラス　昇順',
      sortingType: 'class_name',
      ascendingStatus: true
    },
    {
      id: 1,
      title: 'クラス　降順',
      sortingType: 'class_name',
      ascendingStatus: false
    },
    {
      id : 2,
      title : '基準日　新しい順',
      sortingType : 'course_started_at',
      ascendingStatus : false
    },
    {
      id : 3,
      title : '基準日　古い順',
      sortingType : 'course_started_at',
      ascendingStatus : true
    }
  ];
  
  constructor(
  	private messageService: MessageService,
  	private http: Http,
    private authService: AuthService,
    private pagerService:　PagerService,
    private globalService: GlobalService,
  ) {
  }
  //---------------------------------- Getting API data with subscribe ---------------------------------------------------
  //Getting Login API  

  // Getting All Course data for dashbaord
  // Type : Get
  // Parse :
  getCustomerDashboardApi(){
    // console.log('getCustomerDashboardApi()');
    return this.http.get( this.domain + 'dashboard' , this.authService.options).map(res => res.json());    
  }

  // Getting course dashboard search by filter and search keyword
  // Type : Get
  // Parse :
  getApiByFilterAndSearchApi(FilterValue, SearchValue){
    var parseValue = {
      status : FilterValue,
      keyword : SearchValue 
    }
    var link = "";
    //Search if by login Role
    if(this.authService.role == "admin"){
      link = 'dashboard/adminsearch';
    }else{
      link = 'dashboard/search';
    }

    return this.http.post(this.domain + link, parseValue , this.authService.options).map(res => res.json());    
  }

  // getting Notice in dashboard
  // Type : Get
  // Parse :
  apiNotice() {
    // const url = "https://www.mocky.io/v2/5b164ff331000059006f3df1";
    // return this.http.get(url, this.authService.options).map(res => res.json());
    return [{}];
  }

  // updating the status of course become CANCEL
  // Type : PUT
  // Parse :
  cancelCourseAPi(course_codeval){
    var parseData = {
      course_code : course_codeval
    }

    return this.http.post(this.domain + 'dashboard/cancel', parseData, this.authService.options).map(res => res.json());
  }

  deleteStudentPrivateDataAPi(course_codeval){
    var parseData = {
      course_code : course_codeval
    }

    return this.http.post(this.domain + 'dashboard/deleteStudentPrivateData', parseData, this.authService.options).map(res => res.json());
  }

  // delete course setting of course become reset
  // Type : PUT
  // Parse :
  resetCourseAPi(course_codeval){
    var parseData = {
      course_code : course_codeval
    }

    return this.http.post(this.domain + 'dashboard/course_setting_reset', parseData, this.authService.options).map(res => res.json());
  }

  apiCheckBeforeDownload(url) {
    return this.http.get(url, this.authService.options).map(res => res.json());
  }
  apiFileDownload(url) {
    this.authService.refresh_nowToken_on_options_file_download();
    return this.http.get(url, this.authService.options_file_download).map(response => response.blob());
  }
  // ---------------------------------- Process subcribe API data --------------------------------------------------------
   /** @function
    * @name getCustomerDashboard
    * 
    * @todo  Get all dashboard data by getCustomerDashboardApi
    *  */
  getCustomerDashboard(){
    // console.log('getCustomerDashboard()' + this.authService.role);
    if (this.authService.role == 'customer') {
      forkJoin([
        this.getCustomerDashboardApi()
        // this.apiNotice()
      ]).subscribe(response => {
        this.successResponse(response[0]);
        // this.notices.next(response[1]);
      });
    } else {
      this.getCustomerDashboardApi().subscribe( data => {
        this.successResponse(data);
      }, 
      err => {
        return err;
      });
    }
  }

   /** @function
    * @name getApiByFilterAndSearchProcess
    * 
    * @param {string} FilterValue FIlter data value from form
    * @param {string} SearchValue search keyword value from form 
    * @todo  Get all dashboard data by getCustomerDashboardApi
    *  */
  getApiByFilterAndSearchProcess(FilterValue, SearchValue){
    this.getApiByFilterAndSearchApi(FilterValue,SearchValue).subscribe( data => {
      this.successResponse(data);
    },
    err => {
        return err;
    });
  }

   /** @function
    * @name getApiByFilterAndSearchProcess
    * 
    * @param {string} FilterValue FIlter data value from form
    * @param {string} SearchValue search keyword value from form 
    * @todo  Cheking the data will get All data or getting filter data
    *  */
  getApiByFilterAndSearch(FilterValue, SearchValue){
    if(FilterValue == "" && (SearchValue == "" || SearchValue == undefined )){
      this.getCustomerDashboard();
    }
    else{
      this.getApiByFilterAndSearchProcess(FilterValue, SearchValue);
    }
  }

  /** @function
    * @name cancelCorse
    * 
    * @param {string} course_codeval course code that the status want to be change
    * @todo  change status course code
    *  */
  cancelCourse(course_codeval){
    return new Promise<any>((resolve, reject) => {
      this.cancelCourseAPi(course_codeval).subscribe( result => {
        resolve(result);
      },err => {
        console.log(err);
      });
    });
  }

  deleteStudentPrivateData(course_codeval){
    return new Promise<any>((resolve, reject) => {
      this.deleteStudentPrivateDataAPi(course_codeval).subscribe( result => {
        resolve(result);
      },err => {
        console.log(err);
      });
    });
  }

  resetCourse(course_codeval){
    return new Promise<any>((resolve, reject) => {
      this.resetCourseAPi(course_codeval).subscribe( result => {
        resolve(result);
      },err => {
        console.log(err);
      });
    });
  }

   /** @function
    * @name successResponse
    * 
    * @param {array} data Data from API
    * @todo  parsinf success data to set page
    *  */  
  successResponse(data) {
    this.dashboardsAll = data;
    this.setPage(1);
  }

   /** @function
    * @name setPage
    * 
    * @param {int} page number pagination to display
    * @todo  Setting pagination , divide by total items and sorting the user data
    *  */
  setPage(page: number) {
    if (page < 1) {
      return;
    }
    if(this.dashboardsAll !== undefined){
      this.dashboardsAll = this.pagerService.getSorting(this.dashboardsAll,this.sortingConsultant , this.Acs);
    
      // get pager object from service
      this.pagerProcess = this.pagerService.getPager(this.dashboardsAll.length, page, this.totalItems);
      //get current page of items
      this.dashboards.next(this.dashboardsAll.slice(this.pagerProcess.startIndex, this.pagerProcess.endIndex + 1)) ;
      this.pager.next(this.pagerProcess);  
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/component/aplication/dashboard/dashboard.service.ts